module.exports = __webpack_public_path__ + "img/1134.1490d834.gif";